<template>
    <div>
        <c-search-form :create-div="createDiv"
                       :search-div="searchDiv"
                       :fields="fields"
                       :form-name="formName"
                       :input-create-items="createItems"
                       :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :accept-copy="false"
                       :accept-delete="false"
                       :accept-create="false"
                       key-property="filesDocumentId"
                       search-url="/document/list"
                       form-type="intable"
                       ref="documentList"
                       @onView="viewDocument">

        </c-search-form>
    </div>
</template>

<script>
    import CSearchForm from "../../components/form/ManageForm";
    import axios from "axios";
    import {router} from '../../router';

    export default {
        name: 'file-list',
        components: {
            CSearchForm,
        },
        data: () => {
            return {
                formName: "lang.files.title",
                createFormName: "lang.files.titleCreate",
                searchDiv: "searchDivFile",
                createDiv: "createDivFile",
                searchItems: [],
                createItems: [],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'documentCode',
                        text: 'lang.procedure.documentCode',
                        name: 'documentCode',
                        width: "15%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                        event: "onView"
                    },
                    {
                        value: 'documentName',
                        text: 'lang.procedure.documentName',
                        name: 'documentName',
                        width: "20%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                    },
                    {
                        value: 'documentDate',
                        text: 'lang.procedure.documentDate',
                        name: 'documentDate',
                        dateFormat:'dd/MM/yyyy',
                        width: "20%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                    },
                    {
                        value: 'task',
                        text: 'lang.task.taskname',
                        name: 'task',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                    },
                ],
                selectProc: null,
                feeDlg: false,
                requestInFileDlg: false,
                waitingRequestDlg: false,
                file: null
            }
        },
        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/active-user", {}).then(
                data => {
                    this.fields.filter(e => e.name == "manageId")[0].items = data.items;

                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    this.fields.filter(e => e.name == "customerId")[0].items = data.items;
                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/procedure", {}).then(
                data => {
                    this.fields.filter(e => e.name == "procedureId")[0].items = data.items;
                }
            )


        },

        methods: {
            cancelCreateFile() {
                this.$store.commit("files/setIsView", "0")
                this.$refs.fileList.hideCreateFormAndSearch();
            },
            viewFile(file) {
                document.getElementById(this.searchDiv).style.display = "none";
                document.getElementById("viewFileDiv").style.display = "";
                this.$store.commit("files/setIsView", "1")
                this.file= file;
            },
            onViewCancel() {
                document.getElementById(this.searchDiv).style.display = "";
                document.getElementById("viewFileDiv").style.display = "none";
                this.$store.commit("files/setIsView", "0")
            },

        },
        watch: {
            requestInFileDlg: function (value) {
                if (value == false) {
                    this.$refs.document.cancelFilesRequest();
                }
            },
            waitingRequestDlg: function (value) {
                if (value == false) {
                    this.$refs.waitingRequestDocument.cancelWaitingRequest();
                }
            }
        },

        destroyed() {
        }
    }
</script>
